"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgArrowUp(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12.313.149l.085.073 8.101 8.102a.76.76 0 01-.989 1.147l-.085-.073-6.805-6.805v20.648a.76.76 0 01-1.512.103l-.007-.103V2.592L4.297 9.398a.76.76 0 01-.99.073l-.085-.073a.76.76 0 01-.073-.99l.073-.084L11.324.222a.76.76 0 01.989-.073z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgArrowUp;
exports.default = _default;